<div class="floor">
  <div class="floor-banner" *ngIf="isCommunicationMethodsFound !== undefined && !isCommunicationMethodsFound">
    <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
    <span>
      Billing &amp; shipping address not found.
      <a routerLink="/MyAccount/2">Add them in My Account</a>
      to grab a seat.
    </span>
  </div>

  <ul class="floor-legend">
    <li><span class="swatch swatch--open"></span> Available</li>
    <li><span class="swatch swatch--held"></span> Selected</li>
    <li><span class="swatch swatch--wait"></span> Pending</li>
    <li><span class="swatch swatch--sold"></span> Booked</li>
  </ul>

  <div class="floor-main">
    <p class="floor-empty" *ngIf="seats.available !== undefined && seats.available.length === 0">
      No seats left on this webinar.
    </p>

    <div class="floor-table">
      <div class="floor-stage" aria-hidden="true">Winner reveal</div>
      <div class="seat-grid">
        <div
          class="seat-tile"
          *ngFor="let seat of webinar?.webinarSeats"
          (click)="seat.statusId == '1' && SelectSeat(seat.seatId)"
          [class.is-held]="seat.selected"
          [class.is-open]="!seat.selected && seat.statusId == '1'"
          [class.is-wait]="seat.statusId == '2'"
          [class.is-sold]="seat.statusId == '3'"
          [attr.aria-label]="'Seat ' + seat.seatNumber">
          <span class="seat-num">{{ seat.seatNumber }}</span>
          <span class="material-icons seat-icon">chair</span>
        </div>
      </div>
    </div>
  </div>

  <aside class="floor-side">
    <div class="floor-checkout">
      <div class="floor-total" *ngIf="noOfSeatsSelected > 0">
        <small>Your hold</small>
        <strong>{{ displaySelectedTotal }}</strong>
        <span>{{ noOfSeatsSelected }} × {{ displayUnitPrice }}</span>
      </div>
      <div class="floor-total floor-total--empty" *ngIf="noOfSeatsSelected === 0">
        <small>Your hold</small>
        <strong>Pick a seat</strong>
      </div>
      <a
        class="seat-cta"
        role="button"
        tabindex="0"
        [class.seat-cta--off]="noOfSeatsSelected === 0"
        (click)="noOfSeatsSelected > 0 && AddToCart()"
        (keyup.enter)="noOfSeatsSelected > 0 && AddToCart()">
        <i class="fa fa-shopping-cart" aria-hidden="true"></i>
        Add to cart
      </a>
    </div>

    <div class="floor-timer" *ngIf="cartRemainingTime !== '' && cartRemainingTime !== '0'">
      <mat-icon>av_timer</mat-icon>
      Complete checkout within <strong>{{ cartRemainingTime }}</strong>
    </div>
  </aside>
</div>
